import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { BsWhatsapp } from "react-icons/bs";
import { BASE_URL } from "../data/baseURL";

const ApplyByWhtsApp = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const applyByWhatsApp = (data, e) => {
    setLoading(true);
    fetch(`${BASE_URL}/add-job-cv`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        f_name: data.firstName,
        l_name: data.lastName,
        phone_no: data.phoneNo,
        email: data.email,
        about_us: data.aboutUs,
        job_title: data.jobPosition,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          e.target.reset();
          setLoading(false);
          window.location.replace("https://wa.me/+201103824442");
        }
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-9 ms-auto">
          <p
            name=""
            className="w-100 py-4 px-2 bg-success border-0 text-white gilroy-bold fs-18 text-center cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#carerModal"
          >
            <BsWhatsapp className="fs-28 me-2" /> Apply by whats app
          </p>
        </div>
      </div>
      <div
        className="modal fade"
        id="carerModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header p-5">
              <h1
                className="modal-title fs-20 gilroy-bold text-danger"
                id="exampleModalLabel"
              >
                This application method only for Junior Position
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body fs-16 p-5">
              <div className="text-center pb-5">
                <p className="gilroy-bold fw-700">
                  التقديم من خلال الوتساب. خيار التقديم من خلال الوتساب ينطبق
                  فقط على الفنيين
                </p>
                <p className="gilroy-bold fw-700">
                  والوظائف المبتدئة، بالنسبة لجميع الوظائف العليا بما في ذلك
                  الهندسة والإدارة ، يجب ملء استمارة التقديم، وإلا فسيتم تعليق
                  طلبك حتى إكمال استمارة طلب الوظيفة.
                </p>
              </div>
              <form onSubmit={handleSubmit(applyByWhatsApp)} className="px-5">
                <div className="row mb-5">
                  <div className="col-md-3 my-auto">
                    <p className="gilroy-bold">First Name</p>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="w-100 py-3 px-2"
                      {...register("firstName", { required: true })}
                    />
                    {errors.firstName && (
                      <span className="text-danger ms-4">
                        *First Name Required!
                      </span>
                    )}
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-3 my-auto">
                    <p className="gilroy-bold">Last Name</p>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="w-100 py-3 px-2"
                      {...register("lastName", { required: true })}
                    />
                    {errors.lastName && (
                      <span className="text-danger ms-4">
                        *Last Name Required!
                      </span>
                    )}
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-3 my-auto">
                    <p className="gilroy-bold">WhatsApp Number</p>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="w-100 py-3 px-2"
                      {...register("phoneNo", { required: true })}
                    />
                    {errors.phoneNo && (
                      <span className="text-danger ms-4">
                        *Phone Number Required!
                      </span>
                    )}
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-3 my-auto">
                    <p className="gilroy-bold">Email</p>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="email"
                      className="w-100 py-3 px-2"
                      {...register("email")}
                    />
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-3 my-auto">
                    <p className="gilroy-bold">Job Position</p>
                  </div>
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="w-100 py-3 px-2"
                      {...register("jobPosition")}
                    />
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-3">
                    <p className="gilroy-bold">How did you hear about us?</p>
                  </div>
                  <div className="col-md-9">
                    <textarea
                      className="w-100 py-3 px-2"
                      rows="6"
                      {...register("aboutUs", { required: true })}
                    ></textarea>
                    {errors.aboutUs && (
                      <span className="text-danger ms-4">*Required!</span>
                    )}
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-md-3"></div>
                  <div className="col-md-9 ms-auto">
                    <button
                      type="submit"
                      name=""
                      className="w-100 py-4 px-2 bg-success border-0 text-white gilroy-bold fs-18 d-flex align-items-center justify-content-center"
                    >
                      {loading ? (
                        <>
                          <span className="me-2">Processing...</span>
                          <div class="spinner-border text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </>
                      ) : (
                        <span className="">
                          <BsWhatsapp className="me-3 fs-26" /> Easy Apply
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyByWhtsApp;
